<template>
  <div class="tw-h-full tw-relative">
    <div
      class="tw-bg-[#031b41] tw-flex tw-items-center tw-justify-between tw-px-5 tw-h-[55px] tw-py-2 tw-rounded-t-md tw-text-white tw-font-bold"
    >
      <div>{{ gameName }}</div>
      <div v-if="isAuthenticated && gameLink" class="tw-flex">
        <v-btn :color="`${favorite ? '#d4af37' : 'white'}`" icon @click="toggleFavorite" :loading="isLoading">
          <v-icon>mdi-heart{{ favorite ? "" : "-outline" }} </v-icon>
        </v-btn>
        <v-btn icon @click="toggleFullscreen" :loading="isLoading">
          <v-icon>mdi-fullscreen </v-icon>
        </v-btn>
        <v-btn icon @click="initGame" :loading="isLoading">
          <v-icon>mdi-reload </v-icon>
        </v-btn>
        <v-btn icon @click="gotoHome" :loading="isLoading">
          <v-icon>mdi-close </v-icon>
        </v-btn>
      </div>
    </div>
    <v-divider class="tw-border-[#2994ff] tw-border-[1px]"></v-divider>
    <div class="tw-bg-[#031b41] tw-rounded-b-md tw-h-[76.5vh] tw-relative tw-flex tw-items-center tw-justify-center">
      <iframe
        @load="gameLoad"
        ref="gameframe"
        v-if="gameLink && !isLoading"
        width="100%"
        height="100%"
        :src="gameLink"
        title="Play Casino"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin allow-popups"
      ></iframe>
      <div v-else>
        <v-progress-circular
          v-if="isAuthenticated || isLoading"
          :size="50"
          color="#fff"
          indeterminate
        ></v-progress-circular>
        <div v-else-if="isAuthenticated == false">
          <span class="tw-text-[#aaa] tw-text-xl">Please Login</span>
        </div>
        <div v-else>
          <span class="tw-text-[#aaa] tw-text-xl">Please Reload the page</span>
        </div>
      </div>
    </div>
    <app-error :show="errorDialog.show" :errors="errorDialog.errors"></app-error>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { gameApi } from "../../api";

export default {
  data: () => ({
    game: null,
    searchText: "",
    gameLink: null,
    isAuthenticated: null,
    isLoading: false,
    isAllowed: false,
    favorite: false,
    errorDialog: {
      redirect: true,
      show: false,
      errors: [],
    },
  }),
  async mounted() {
    if (!this.$auth || !this.$auth.user) {
      this.isAuthenticated = false;
      return;
    }
    this.isAuthenticated = true;
    let game = null;

    game = await this.getGameById({ id: this.getSetGameId });
    if (!game) {
      //get first casino game
      game = await this.getFirstGame({ type: this.getMode });
    }
    this.game = game;
    this.favorite = game.is_favorite;
    this.$emit("selectedGame", game);
    await this.initGame();
  },
  computed: {
    getSetGameId() {
      return (this.$route.params && this.$route.params.id) || 0;
    },
    getMode() {
      return this.$route.params.type;
    },
    gameName() {
      return this.game && this.game.name;
    },
  },
  watch: {
    "$route.params.id": async function () {
      let game = null;
      game = await this.getGameById({ id: this.getSetGameId });
      if (!game) {
        //get first casino game
        game = await this.getFirstGame({ type: this.getMode });
      }
      this.game = game;
      this.favorite = game.is_favorite;
      this.$emit("selectedGame", game);
      await this.initGame();
    },
  },
  methods: {
    ...mapActions("game", ["gameInitDemo", "gameInit", "gameInitDemo", "getGameById", "getFirstGame"]),
    ...mapMutations("game", ["setPlayBackground", "setPlayGame"]),
    async initGame() {
      let name = this.gameName;
      try {
        if (name) {
          if (this.game.has_lobby) {
            this.setPlayGame("Live Casino");
          } else {
            this.setPlayGame(name);
          }
          let names = name.split(" ");
          names = names.map((name) => {
            return this.toPascalCase(name);
          });
          names = names.filter((name) => {
            if (name.toLowerCase() == "mobile") return false;
            return true;
          });
          name = names.join("");
        }
      } catch (err) {
        console.log(err);
      }
      // this.setPlayBackground(
      //   `https://test.endorphina.com/games-wgl/endorphina2/${name}/resources/graphics/background/bgslot_bottom.jpg`
      // );
      if (this.$route.params.type == "demo-live" || this.$route.params.type == "demo-slots") {
        await this.startGameDemo();
      } else {
        await this.startGame();
      }
    },
    async startGameDemo() {
      this.isLoading = true;
      let payload = {
        game_id: this.game.id,
      };
      const res = await this.gameInitDemo(payload);
      if (res && res.success) {
        this.gameLink = res.data && (res.data.url || null);
      }
      if (res.redirect) {
        return (location.href = process.env.VUE_APP_SERVER_ENV == "prod" ? "/casino-games" : "/");
      }
      this.isLoading = false;
    },
    async startGame() {
      this.isLoading = true;
      let payload = {
        game_id: this.game.id,
        return_url: window.location.protocol + "//" + window.location.host + "/casino-games",
      };

      const res = await this.gameInit(payload);
      if (res && res.success) {
        this.gameLink = res.data && (res.data.url || null);
      }
      if (!res.success) {
        if (res.redirect || (this.$auth.user && !this.$auth.is_super_admin && this.$auth.user.type != "admin")) {
          return (location.href = process.env.VUE_APP_SERVER_ENV == "prod" ? "/casino-games" : "/");
        }
        this.errorDialog.show = true;
        this.errorDialog.errors = {
          title: "Warning",
          body: res.message,
        };
      }
      this.isLoading = false;
    },

    selectLobby(lobby) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          d: lobby.lobbyData,
        },
      });
    },
    async changeMode(mode) {
      if (this.$route.params.type != mode) {
        await this.$router.push({
          name: "Play",
          params: { type: mode, game_id: this.game.id },
        });
        await this.initGame();
      }
    },
    gameLoad(e) {
      try {
        if (
          this.$refs.gameframe.contentWindow.location &&
          this.$refs.gameframe.contentWindow.location.href &&
          this.$refs.gameframe.contentWindow.location.href != "about:blank"
        ) {
          return (location.href = this.$refs.gameframe.contentWindow.location.href);
        }
      } catch (e) {}
    },
    toPascalCase(string) {
      return `${string}`
        .replace(new RegExp(/[-_]+/, "g"), " ")
        .replace(new RegExp(/[^\w\s]/, "g"), "")
        .replace(new RegExp(/\s+(.)(\w*)/, "g"), ($1, $2, $3) => `${$2.toUpperCase() + $3.toLowerCase()}`)
        .replace(new RegExp(/\w/), (s) => s.toUpperCase());
    },

    toggleFullscreen() {
      const iframe = this.$refs.gameframe;

      if (iframe.requestFullscreen) {
        iframe.requestFullscreen();
      } else if (iframe.mozRequestFullScreen) {
        iframe.mozRequestFullScreen();
      } else if (iframe.webkitRequestFullscreen) {
        iframe.webkitRequestFullscreen();
      } else if (iframe.msRequestFullscreen) {
        iframe.msRequestFullscreen();
      }
    },
    async toggleFavorite() {
      try {
        const response = await gameApi.post(`/games/${this.game.uuid}/favorites`, {
          favorite: !this.favorite,
        });
        if (response.data.success) {
          this.favorite = response.data.added;
        }
      } catch (error) {
        console.log(error);
      }
    },
    gotoHome() {
      return (location.href = process.env.VUE_APP_SERVER_ENV == "prod" ? "/casino-games" : "/");
    },
  },

  beforeRouteLeave(to, from, next) {
    if (!window.confirm("Want to leave playing?")) {
      return next(false);
    }
    next();
  },

  metaInfo() {
    const game = this.gameName;
    return {
      titleTemplate: (chunk) => `${chunk}: ${game ? "Playing " + game : "Login to Play"}`,
    };
  },
};
</script>

<style></style>
